import ReactInputMask from "react-input-mask";

import {
  FormControl,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormErrorMessage,
} from "@chakra-ui/react";
import { forwardRef, ForwardRefRenderFunction } from "react";
import { FieldError } from "react-hook-form";

interface Props extends ChakraInputProps {
  name: string;
  mask: string;
  label?: string;
  size?: "lg" | "md" | "sm";
  error?: FieldError;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  { name, mask, label, size = "sm", error, ...rest },
  ref
) => {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel mb={-1} color="gray.800" htmlFor={name}>
          {label}
        </FormLabel>
      )}

      <ChakraInput
        {...rest}
        id={name}
        name={name}
        borderColor="gray.600"
        focusBorderColor="green.400"
        borderBottomWidth={2}
        variant="flushed"
        size={size}
        _hover={{
          bgColor: "transparent",
        }}
        ref={ref}
        as={ReactInputMask}
        mask={mask}
        maskChar={null}
      />
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const InputLineMask = forwardRef(InputBase);
